import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Button } from './Button';
import { Logo } from './Header';

const content=[
  {title:(name:string)=>`Welcome, ${name} — this is the live picture.`,body:'ZENITH combines field observations with verified conflict data, so the Guild can separate signal from noise.'},
  {title:()=> 'OPSEC is part of the signal.',body:'Use codenames. Never share personal information. Report travel only after you have left a location.'},
  {title:()=>"You're in.",body:'Observe carefully, label uncertainty, and add context that helps the next analyst.'},
];

export function Onboarding(){
  const{profile,finishOnboarding}=useAuth();
  const[index,setIndex]=useState(0);
  const item=content[index]??content[0];
  if(!item)return null;
  return <div className="onboarding"><section><Logo full /><div className="onboarding__step">0{index+1} / 03</div><h1>{item.title(profile?.codename??'ANALYST')}</h1><p>{item.body}</p><div className="onboarding__dots">{content.map((_,i)=><i className={i===index?'active':''} key={i}/>)}</div><Button onClick={()=>index===2?finishOnboarding():setIndex(index+1)}>{index===2?'Open live brief':'Continue'}</Button><button className="guest-link" onClick={finishOnboarding}>Skip onboarding</button></section></div>;
}
